<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
  reasoning: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();

const hasReasoning = computed(() => !!props.reasoning);
</script>

<template>
  <div
    class="flex flex-col gap-2 text-xs text-n-slate-11 bg-n-alpha-2 rounded-lg p-3"
  >
    <div v-if="hasReasoning" class="flex flex-col gap-2">
      <div class="font-medium text-n-slate-12">
        {{ t('PILOT.COPILOT.REASONING') }}
      </div>
      <div class="whitespace-pre-wrap">{{ reasoning }}</div>
    </div>
    <div class="flex flex-col gap-2">
      <div class="font-medium text-n-slate-12">
        {{ t('PILOT.COPILOT.TOOL_NAME') }}
      </div>
      <div class="whitespace-pre-wrap font-mono">{{ content }}</div>
    </div>
  </div>
</template>
